const {log} = console;

const ZERO = 0;
const ONE = 1;
const FIFTY = 50;
const STYLESHEET_CHECK_TIMEOUT = FIFTY;
const MINUS_ONE = -1;

class AmdModuleLoader {

    constructor () {
        this.listeners = {};
        this.resolves = {};
        this.options = {
            baseUrl: ''
        };
    }

    config (properties) {
        Object.keys(properties)
            .forEach((property) => {
                this.options[property] = properties[property];
            });
    }

    addLoadListener (listener, name) {
        log('addLoadListener', name);
        if (Object.keys(this.resolves).includes(name)) {
            // value is already loaded, call listener immediately
            listener(name, this.resolves[name]);
        } else if (this.listeners[name]) {
            this.listeners[name].push(listener);
        } else {
            this.listeners[name] = [listener];
            // first time this dependency is requested
            // get the loader name from string before ! character
            this.require(['js!' + name.split('!')[0] ], (loader) => {
                loader(name);
            });
        }
    }

    resolve (name, value) {
        log('resolve', name);
        this.resolves[name] = value;
        const libListeners = this.listeners[name];
        if (libListeners) {
            libListeners.forEach((listener) => {
                listener(name, value);
            });
            // remove listeners (delete listeners[name] is longer)
            this.listeners[name] = ZERO;
        }
    }

    require (deps, definition) {
        log('require', deps);
        const length = deps.length;
        if (length) {
            if (typeof deps === 'string') {
                deps = deps.split(' ');
            }
            // we need to wait for all dependencies to load
            const values = [];
            let loaded = ZERO;

            deps.forEach(this.addLoadListener.bind(this, (name, value) => {
                values[deps.indexOf(name)] = value;
                loaded = loaded + ONE;

                if (loaded+=ONE >= length) {
                    definition.apply(definition, values);
                }
            }));
        } else {
            // no dependencies, run definition now
            definition();
        }
    }

    define (name, deps, definition) {
        log('define', name);
        if (definition) {
            // asynchronous define with dependencies
            this.require(deps, (...args) => {
                this.resolve(name, definition.apply(definition, args));
            });
        } else {
            // just two arguments - bind name to value (deps) now
            this.resolve(name, deps);
        }
    }

    addElement (name, properties) {
        log('addElement', name);
        const element = document.createElement(name);
        Object.keys(properties).forEach((property) => {
            element[property] = properties[property];
        });
        document.head.appendChild(element);
    }

}

const Loader = window.Loader = global.Loader = new AmdModuleLoader();
const RemoteUrlPattern = /(http\:)?\/\//;

Loader.define('js!js', (name) => {
    log('jsPlugin', name);
    let fileName = name.split('!')[ONE];
    if (!fileName.match(RemoteUrlPattern)) {
        fileName = `${Loader.options.baseUrl}${fileName}`;
        log('jsPlugin.isLocal', fileName);
    }
    Loader.addElement('SCRIPT', {
        src: fileName
    });
});

Loader.define('js!css', (name) => {
    log('cssPlugin', name);
    const fileName = name.split('!')[ONE];
    function check () {
        document.styleSheets.forEach((sheet) => {
            if (sheet.href && sheet.href.indexOf(fileName) > MINUS_ONE) {
                return Loader.define(name);
            }

            return name;
        });
        // style is loaded but not being applied yet
        setTimeout(check, STYLESHEET_CHECK_TIMEOUT);
    }
    Loader.addElement('LINK', {
        href: fileName,
        rel: 'stylesheet',
        onload: check
    });
});

window.Loader = Loader;


const toLoad = document.body.getAttribute('data-load');
if (toLoad && toLoad.length > ZERO) {
    log('initBodyLoad', name);
    // require dependencies specified in <body data-load attribute
    setTimeout(Loader.require.bind(Loader, toLoad.split(' '), Date), ZERO);
}
